import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Card } from 'ui-components/components/card';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

// @ts-expect-error less import
import style from '../style.module.less';

/**
 * @typedef {import('react-intl').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {MessageDescriptor} props.title
 * @param {MessageDescriptor} props.description
 * @param {number} props.stepNumber
 * @returns {JSX.Element}
 */
export const ProcessStep = ({ title, description, stepNumber }) => {
  return (
    <Card className={style['process-step-container']}>
      <FlexColumn className={style['process-step']}>
        <div className={style['process-step-number']}>
          <Text textType={TextType.H1} value={<FormattedNumber value={stepNumber} />} />
        </div>
        <FlexColumn gap={Gap.Space8}>
          <Text textType={TextType.H3} value={title} />
          <Text className={style['process-step-description']} textType={TextType.Description} value={description} />
        </FlexColumn>
      </FlexColumn>
    </Card>
  );
};
